import React from 'react';
import SVG from 'react-inlinesvg';
import { Container } from 'styles';
import Megaphone from '/images/notification-icons/megaphone.svg';
import Energy from '/images/notification-icons/energy.svg';
import MovingTruck from '/images/notification-icons/moving-truck.svg';
import SolarPanel from '/images/notification-icons/solar-panel.svg';
import LmiHousehold from '/images/notification-icons/lmi-household.svg';
import { NotificationKey } from 'domain/notifications';

interface Props {
  notificationKey: QueriedNotification['notificationKey'];
}

export const getIconFromKey = (key: QueriedNotification['notificationKey']) => {
  switch (key) {
    case NotificationKey.advocacyCampaignAvailableForAccount:
      return { icon: Megaphone, testId: 'megaphone-icon' };
    case NotificationKey.signContract:
    case NotificationKey.signStateContracts:
      return { icon: SolarPanel, testId: 'solar-panel-icon' };
    case NotificationKey.finalBill:
    case NotificationKey.movingAccountDeleted:
      return { icon: MovingTruck, testId: 'moving-truck-icon' };
    case NotificationKey.lowIncomeHousehold:
      return { icon: LmiHousehold, testId: 'lmi-household-icon' };
    default:
      return { icon: Energy, testId: 'energy-icon' };
  }
};

export const NotificationSVG = ({ notificationKey }: Props) => {
  const { icon, testId } = getIconFromKey(notificationKey);
  return (
    <Container margin={{ bottom: '32px', right: '24px' }}>
      <SVG
        aria-hidden={true}
        src={icon}
        height="80px"
        width="80px"
        data-testid={testId}
      />
    </Container>
  );
};
